module.exports = __webpack_public_path__ + "img/ics_o_download_circle_disabled.361979b9.svg";